import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../components/shared/Loader";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import { updateMeta } from "../../store/actions/metaAction";
import { Col, Row, Container } from "reactstrap";
import { v4 } from "uuid";

const BrandsCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [brand, setBrand] = useState({});
	const [loading, setLoading] = useState(false);
	const [picture, setPicture] = useState({
		blob: true,
		path: userPlaceholder,
		placeholder: true,
	});
	const dispatch = useDispatch();

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة ماركة جديدة",
				breadcrumb: "الماركات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
	};

	useEffect(() => {
		onStart();
	}, []);

	const handlePicture = e => {
		const fileInput = document.querySelector(`#${e.target.id}`);
		try {
			setPicture({
				path: URL.createObjectURL(fileInput.files[0]),
				blob: true,
				placeholder: false,
			});
		} catch (error) {}
	};
	const handleSubmit = e => {
		e.preventDefault();
		if (picture.placeholder || !brand.name.ar || !brand.name.en) {
			toast.warn("الرجاء ادخال جميع البيانات المطلوبة");
			return;
		}
		const pictureElement = document.querySelector("#picture");
		const mainImage = new FormData();
		mainImage.append("file", pictureElement.files[0]);
		axios
			.post(`${process.env.REACT_APP_MAIN_URL}/api/upload`, mainImage, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(response => {
				const data = {
					...brand,
					title: "comment",
					image: {
						path: response.data.data.file.path,
						blob: false,
						placeholder: false,
					},
				};
				axios
					.post(
						`${process.env.REACT_APP_API_URL}pages/brands/sections`,
						{
							section: data,
						},
						{
							headers: {
								Authorization: `Bearer ${cookie.get("token")}`,
								Accept: "application/json",
							},
						}
					)
					.then(
						_ =>
							toast.success("تم اضافة ماركة بنجاح") &&
							history.push("/brands/index")
					)
					.catch(_ => toast.error("حدث خطا !"));
			})
			.catch(_ => {
				toast.error("حدث خطا أثناء رفع الصورة");
				setTimeout(
					__ => toast.warn("الرجاء المحاولة مره اخرة او تغير الصورة"),
					800
				);
			});
	};

	return (
		<section>
			<Container>
				<div className="card">
					<div className="card-body">
						<Row style={{ marginTop: "2rem" }}>
							<Col
								style={{
									display: "flex",
									flexDirection: "column",
									justifyContent: "flex-start",
									alignItems: "flex-start",
								}}
							>
								<div className="form-item">
									<label htmlFor="clientNameAR">اسم الماركة بالعربية</label>

									<input
										type="text"
										id="clientNameAR"
										name="clientNameAr"
										onChange={e => {
											setBrand({
												...brand,
												name: { ...brand.name, ar: e.target.value },
											});
										}}
									/>
								</div>
							</Col>

							<Col
								style={{
									display: "flex",
									flexDirection: "column",
									justifyContent: "flex-start",
									alignItems: "flex-start",
								}}
							>
								<div className="form-item">
									<label htmlFor="clientNameEN">اسم الماركة بالانجليزية</label>

									<input
										type="text"
										id="clientNameEN"
										name="clientNameEn"
										onChange={e => {
											setBrand({
												...brand,
												name: { ...brand.name, en: e.target.value },
											});
										}}
									/>
								</div>
							</Col>
						</Row>

						<Row>
							<Col>
								<div className="form-item">
									<label htmlFor="picture">صورة الماركة</label>
									<input
										type="file"
										onChange={handlePicture}
										id="picture"
										accept="image/*"
									/>
									<img
										src={
											picture && picture.blob
												? picture.path
												: `${process.env.REACT_APP_MAIN_URL}/${picture.path}`
										}
										alt="avatar"
										className="imagePreview-2"
									/>
								</div>
							</Col>
						</Row>

						<Row>
							<Col>
								<div className="form-item mt-3">
									<button
										className="bt bt-success btn-block"
										onClick={handleSubmit}
									>
										ارسال
									</button>
								</div>
							</Col>
						</Row>
					</div>
				</div>
			</Container>
		</section>
	);
};

export default BrandsCreate;
